<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <h4>{{ clerk.name }}</h4>

            <form-group label="Branches" :required="true">
              <span v-for="item in branches" :key="item.id">
                <b-form-checkbox v-model="clerk.branches" :value="item.id">
                  {{ item.name }}
                </b-form-checkbox>
              </span>
              <div class="text-danger" v-if="$v.clerk.branches.$error">
                Please select branches
              </div>
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import clerkRepo from "@/api/repos/clerkRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    clerk: {
      user_id: {
        required,
      },
      branches: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
    this.getClerk();
  },

  props: ["id"],

  data() {
    return {
      clerk: {},
      branches: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await clerkRepo.createGetData();
        this.branches = data.branches;
      } catch (error) {
        console.log(error);
      }
    },
    async getClerk() {
      try {
        this.loading = true;
        let { data } = await clerkRepo.get(this.id);
        this.clerk = data.clerk;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await clerkRepo.update(this.id, this.clerk);
          this.$emit("clerkUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
